import React from 'react'

// Between part 1 and part 2. The warm-up is scored off-call by the research team, so
// there is a real human gap here — this screen exists so a participant who reopens
// their link during it sees a status rather than assuming the link is broken.
export default function WaitingStep ({ excluded }) {
  if (excluded) {
    return (
      <div className="study-card study-done">
        <h2 className="study-h2">Thank you for taking part</h2>
        <p>
          You’ve completed the first session, and that’s everything we need from you.
          We won’t be scheduling the remaining parts.
        </p>
        <p className="study-hint">
          Any compensation for today will be handled as described in your invitation.
        </p>
      </div>
    )
  }

  return (
    <div className="study-card study-done">
      <div className="study-done__check">✓</div>
      <h2 className="study-h2">Part 1 complete</h2>
      <p>
        Thanks — that’s today’s session done. We’re reviewing the warm-up exercise now.
      </p>
      <p>
        If you continue, you’ll get an <b>email with your link for Part 2</b>. It’s the
        same link you used today, so you can keep this page bookmarked.
      </p>
      <p className="study-hint">
        Part 2 takes about 80–90 minutes and runs in timed blocks, so start it when you
        have an uninterrupted stretch. You can close this window now.
      </p>
    </div>
  )
}
